<template>
  <div v-if="user" class="container-fluid mt-3 mb-3">
    <div class="d-flex align-items-center mb-3">
      <h3 class="m-0 p-0">
        <i class="fa fa-user mr-3"></i>
        {{ user.username }}
      </h3>
    </div>
    <div class="mb-3">
      <v-user-statistics-table
        :user-id="parseInt($route.params.id)"
      />
    </div>
    <div class="row" v-if="user">
      <div class="col-md-12">
        <div class="card">
          TO BE CONTINUED...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GenericDetailMixin } from '@/common/utils/mixins';
import UserStatisticsTable from '../components/UserStatisticsTable.vue';

export default {
  name: 'UserDetail',
  components: {
    'v-user-statistics-table': UserStatisticsTable,
  },
  mixins: [
    GenericDetailMixin,
  ],
  data() {
    return {
      objectName: 'user',
      user: null,
    };
  },
  methods: {
    getApiPath() {
      return `admin/users/${this.$route.params.id}`;
    },
  },
};
</script>
